'use client';

import { CircleX } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function LoadFailure({ code, retry }: { code?: string; retry: () => void }) {
  return <div className="mx-auto flex max-w-md flex-col items-start gap-3 rounded-lg border bg-card p-5 text-foreground" role="alert">
    <CircleX className="size-5 text-st-failed-fg" aria-hidden="true" />
    <h1 className="text-xl font-semibold">This page couldn’t load</h1>
    <p className="text-sm text-muted-foreground">Please try again. If the problem continues, share the error code with your administrator.</p>
    {code ? <p className="max-w-full break-all font-mono text-xs text-muted-foreground">{code}</p> : null}
    <Button onClick={retry}>Retry</Button>
  </div>;
}
